import React from "react";
import moment from "moment";
import Clock from "react-live-clock";
import WebCam from "react-webcam";
import { ClockingType, ClockingInput, ClockingView } from "../../../models/attendance";
import { ClientType } from "../../../models/general";
import Timer from "../../../components/timer";
import * as AttendanceApi from "../../../api/Attendance/attendance";
import "./index.css";
import { getFormattedDuration } from "../../../utils";
import { formatLocalDateParam } from "../../../utils/apiDate";
import { withTranslation } from "react-i18next";
import { getUserInfo } from "../../../api/General/account";
import { getStatus, init, updateClockingTimers } from "../../../store/redux/actions/userActionCreator";
import { connect } from "react-redux";

type Props = {
  t: any;
  match: { params: { action?: string, shiftId?: number } }
  getStatus?: any;
  userId?: any;
  firstName?: any;
  init?: any;
  updateClockingTimers?: any;
  now?: any;
  UpdateNow?: any;
  checkTimeRunning?: any;
  currentShift?: any;
  checkBreakTimeRunning?: any;
  incrementWorkingTimer: number;
  incrementTimer?: any;
  checkBreaksTime?: any;
  breaksTime?: any;
  checkTotalBreaksTime?: any;
  totalBreaksTime?: any;
  checkTotalWorkingTime?: any;
  totalWorkingTime?: any;
  today?: any;
  workingTime?: any;
  checkWorkingTime?: any;
  isBreakTimeRunning?: any;
  currentWorkingDuration?:any;
  companyPrimaryColor?:any;
};

type State = {
  dialogVisible: boolean;
  input: ClockingInput;
  clockingType: ClockingType;
  loading: boolean;
  clockingStatus?: ClockingView[];
  error?: string;
};

class Widget extends React.Component<Props, State> {
  interval: NodeJS.Timeout | null;
  webcamRef = React.createRef<WebCam>() as React.RefObject<WebCam> & string;
  gpsRef = React.createRef<any>();
  constructor(props: Props) {
    super(props);
    const { t } = props
    this.interval = null;
    this.state = {
      dialogVisible: false,
      clockingType: ClockingType.ClockIn,
      input : {
        userId: props.userId,
        comments: "",
        clientType: ClientType.Web,
        time: new Date(),
        fullAddress: "",
        hoursOffset: 0,
        image: null,
      },
      loading: false,
    };
  }
  componentDidMount() {
    if (!this.props.firstName)
      getUserInfo().then((data) => this.props.init(data))
    else
      this.props.getStatus(this.props.userId);
    const updateEvery = 1000;
    this.interval = setInterval(() => {
      this.update(updateEvery);
    }, updateEvery);
    if (!this.state.clockingStatus) {
      this.fetch();
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  update = (interval: number) => {
      this.props.updateClockingTimers();
  };

  fetch = async () => {
    this.setState({ loading: true });
    const today = formatLocalDateParam(new Date());
    const { payload } = await AttendanceApi.getClockingsPerDay(this.props.userId, today, today);
    if (payload)
      this.setState({ loading: false, clockingStatus: payload[0] });
    else
      this.setState({ loading: false })
  };

  render() {

    const { t } = this.props;
    const timeTxt = this.props.workingTime ? getFormattedDuration(this.props.workingTime) : "00:00:00";
    const breakTxt = this.props.breaksTime ? getFormattedDuration(this.props.breaksTime) : "00:00:00";
    const totalTimeTxt = this.props.totalWorkingTime
      ? getFormattedDuration(this.props.totalWorkingTime) : "00:00:00";
    const totalBreakTxt = this.props.totalBreaksTime
      ? getFormattedDuration(this.props.totalBreaksTime) : "00:00:00";

    const fullTime = moment.duration(this.props.currentWorkingDuration * 3600000);
    const progress = this.props.workingTime ? this.props.workingTime / fullTime.asSeconds() : 0;

    return (
      <>
        <div className="flex items-stretch">
          <div className="flex flex-1 flex-col items-center justify-start gap-2 p-4">
            <div className="w-full min-w-[250px] max-w-[500px] -mb-[70px]">
              <Timer text={timeTxt} progress={progress} secondaryText={totalTimeTxt} primaryColor={this.props.companyPrimaryColor ?? "#304EA1"} />
            </div>
            <div className="text-xl font-semibold text-center text-foreground">
              <Clock format={"dddd, Do MMMM, h:mm:ss A"} ticking />
            </div>
            <div className="text-sm text-center text-foreground">
              <div>
                <b>{t("Break(shift)-")}</b>
                <span>{breakTxt}</span>
              </div>
              <div>
                <b>{t("Break(today)-")}</b>
                <span>{totalBreakTxt}</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    userId: state.user.userId,
    firstName: state.user.firstName,
    now: state.user.now,
    currentShift: state.user.currentShift,
    incrementWorkingTimer: state.user.incrementWorkingTimer,
    breaksTime: state.user.breaksTime,
    totalBreaksTime: state.user.totalBreaksTime,
    totalWorkingTime: state.user.totalWorkingTime,
    today: state.user.today,
    workingTime: state.user.workingTime,
    isBreakTimeRunning: state.user.isBreakTimeRunning,
    currentWorkingDuration: state.user.currentWorkingDuration,
    companyPrimaryColor: state.user.companyPrimaryColor
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getStatus: (userId: any) => dispatch(getStatus(userId)),
    init: (input: any) => dispatch(init(input)),
    updateClockingTimers: () => dispatch(updateClockingTimers())
  }
}

export default (connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Widget as any) as any);
